module.exports = __webpack_public_path__ + "media/images/icons/flags/KE-4e70d3c262d92ae6961fa408a220466e.svg";